import React from 'react'

import BasicRoute from 'components/routes/BasicRoute'

import CulturaConsulta from 'entity/Cultura/components/CulturaConsulta'
import CulturaForm from 'entity/Cultura/components/CulturaForm'

export default function index() {
    return (
        <>
            <BasicRoute
                perfilAuth={['r9jrEQXznNgjrZTGCfch', 'RECT03jkyTQW9B2OMz47']}//admin ou tecnico
                uid="consulta-cultura"
                route="consulta-cultura"

                menuProps={{
                    text: "Culturas",
                    sequence: "111114",
                    iconName: "LocalFlorist",

                    parent: {
                        uid: "parentCadastros",
                        text: "Cadastros",
                        sequence: "222222",
                        iconName: 'Edit'
                    }
                }}

                element={<CulturaConsulta />}
            />
            <BasicRoute
                uid="cultura"
                route="_cultura"
                element={<CulturaForm />}
            />
        </>
    )
}
